import { render, staticRenderFns } from "./ConsultationList.vue?vue&type=template&id=8409e0a6&scoped=true"
import script from "./ConsultationList.vue?vue&type=script&lang=js"
export * from "./ConsultationList.vue?vue&type=script&lang=js"
import style0 from "./ConsultationList.vue?vue&type=style&index=0&id=8409e0a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8409e0a6",
  null
  
)

export default component.exports